import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  AnalyticsService,
  BalanceService,
  CertificateListService,
  NotificationService,
  ProfileService,
  UserManagementPasswordService,
  WalletService,
  NotificationKeys,
  PaymentStatus,
  ResponseStatus,
  Services,
  UserTypes,
	countries,
  StorageKeys,
  BillingPageView,
  ProcessorStatuses,
  Processors,
  BillingActiveIcons,
  Units,
  BooleanStringValues,
} from "@core";
import { SettingsService } from "@delon/theme";
import { _Validators } from "@delon/util";
import { ActivatedRoute, Router } from "@angular/router";
import { Clipboard } from "@angular/cdk/clipboard";
import { API_ResponseStatus } from "src/app/core/config/api-response.config";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { BrowserStorageKeys } from "src/app/core/config/browser-storage-keys.config";
import { InstitutionDetailStatus } from "src/app/core/enums/institution-detail-status.enum";
import { TranslateService } from "@ngx-translate/core";
import { ExamCountrySetupComponent } from "src/app/shared/helpers/global/exam-country-setup/exam-country-setup.component";

@Component({
  selector: "app-billing",
  templateUrl: "./billing.component.html",
  styleUrls: ["./billing.component.less"],
  standalone: false,
})
export class BillingComponent implements OnInit, OnDestroy {
  redirectUrl = "";
  active = 1;
  profileForm: FormGroup;
  loading: boolean = false;
  isLoading: boolean = false;
  formError: boolean = false;
  isAccountGenerated: boolean = false;
  isGenerated: boolean = true;
  isPaymentOption: boolean = false;
  virtualAccounts: any[] = [];
  unitEquivalent: any;
  unitRate: any;
  currency: any;
	userTypes = UserTypes;
	countries = countries;
  body: any;
  message = "";
  error = "";
  userCountry: any;
  localAccessCost: number = 0;
  localSharingCost: number = 0;
  localRequestConfirmationCost: number = 0;
  localRetrievalCost: number = 0;
  localVerificationCost: number = 0;

  InstitutionDetailStatus = InstitutionDetailStatus;
  isGenerateVirutalAccount: boolean = false;
  virtualAccountGenerationInitiated: boolean = false;
  isAccountGenerationSuccess: boolean = false;
  residentCountry!: string;
  q: {
		amount: number;
    units: number;
    unitRate: number;
    processor: string;
    selectedAmount: number;
  } = {
		amount: 0,
    units: 0,
    unitRate: 1,
    processor: "",
    selectedAmount: 0,
  };
	
  balance = 0;

  pwd = {
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  };

  primary_email: any;
  user: any;
  headerIcon: string = "";
  userDetail: any;

  pageLoading: boolean = false;
  trxerror: boolean = false;
  trxmessage = "";
  views = BillingPageView;
  billing_wallet: string = BillingPageView.HISTORY;
  headerTitle = "BILLING.WALLET";

  isVisible: boolean = false;
  isVisibleNegative: boolean = false;
  wallet_response: any;
  transaction_details: any;

  wallet: any;
  unitBalance: number = 0;
  loading_wallet = true;
  accessCost?: number; // provisionCost?: number;
  verificationCost!: number;
  sharingCost?: number;
  retrievalCost?: number;
  requestConfirmationCost?: number;
  sub: any;
  baseUrl = "";
  dropdownToggle: boolean = true;
  viewServiceChargeModal: boolean = false;
  serviceChargeModalText: string = "BILLING.SERVICE_CHARGE_MODAL_TEXT";
  virtualAccountDetails: any = {};

  @ViewChild(ExamCountrySetupComponent) examCountrySetup!: ExamCountrySetupComponent;


  examCountrySetupModal: boolean = false;


	totalUnits = 0; //this.q.units * this.verificationCost;


  constructor(
    private walletBalance: BalanceService,
    private profileService: ProfileService,
    private passwordService: UserManagementPasswordService,
    private notify: NotificationService,
    fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public msg: NzMessageService,
    private settings: SettingsService,
    private walletService: WalletService,
    private paymentService: CertificateListService,
    private clipboard: Clipboard,
    private BrowserStorage: StorageService,
    private translate: TranslateService,
    private storageSrv: StorageService,
    private analytics: AnalyticsService,
  ) {
    // Email
    this.primary_email = this.settings.user.email;
    this.user = this.profileService.getLocalStorageUser();
    this.headerIcon =
      this.user.type == UserTypes.USER
        ?  BillingActiveIcons.USER
        : BillingActiveIcons.VERIFIER;
    this.userDetail = this.BrowserStorage.getLocalStorageItem(
      BrowserStorageKeys.token,
    );

    this.profileForm = fb.group({
      name: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(`^[-_a-zA-Z0-9]{4,20}$`),
        ]),
      ],
      email: "",
      bio: [null, Validators.maxLength(160)],
      url: "",
      company: "",
      location: "",
    });
    this.user = this.storageSrv.getLocalStorageItem(StorageKeys.TOKEN);
    this.userCountry = this.countries.find((val: any) => val.code === this.user.country);
  }

  ngOnInit(): void {
    this.getWallet();
    this.getUserDetails();
    this.getServiceCost();
    this.loadUnit();
    this.getVirtualAccountDetail();
    this.checkIfVirtualAccountGenerationInitiated();
    this.getVirtualProcessors();
    this.confirmPayment();
    this.user?.type === UserTypes.USER
      ? (this.billing_wallet = BillingPageView.HISTORY)
      : (this.billing_wallet = BillingPageView.FUNDING);
  }

  ngOnDestroy(): void {
    if (this.sub) this.sub.unsubscribe();
  }

  convertUnit() {
    if (Math.sign(this.q.units) == -1) {
      this.q.units = 0;
      return;
    }
    this.q.amount = this.q.units * this.q.unitRate;
		this.totalUnits = this.q.units * this.verificationCost;
  }

  switchViewfundWallet(): void {
    this.billing_wallet = BillingPageView.FUNDING;
    this.q = {
      amount: 0,
      units: 0,
      unitRate: 1,
      processor: "",
      selectedAmount: 0,
    };
  }

  switchViewtransactionHistory(): void {
    this.billing_wallet = BillingPageView.HISTORY;
    this.q = {
      amount: 0,
      units: 0,
      unitRate: 1,
      processor: "",
      selectedAmount: 0,
    };
  }

  loadUnit(): void {
    this.paymentService
      .getUnit()
      .then((res) => {
        if (res.status === ResponseStatus.FAILED) {
          this.error = res.message;
          return;
        }
        this.loading = false;
        this.q.unitRate = res.data;
      })
      .catch((err) => {
        this.error = err;
        this.loading = false;
      });
  }

  displayServiceCharge() {
    this.viewServiceChargeModal = true;
  }

  dismissServiceChargeModal() {
    this.viewServiceChargeModal = false;
  }

  getServiceCost() {
    this.walletService
      .walletServices()
      .then((res) => {
        
				const data = res?.data?.data || [];

				const getCost = (serviceName: string) => {
					const service = data.find((i: any) => i.item?.toLowerCase() === serviceName);
					const unitValue = service?.service_values?.find((v: any) => v.value_text?.toLowerCase() === Units.UNIT);
					return unitValue?.value || 0;
				}

				this.accessCost = getCost(Services.ACCESSING);
				this.verificationCost = getCost(Services.CONFIRMATION);
				this.sharingCost = getCost(Services.SHARING);
				this.requestConfirmationCost = getCost(Services.REQUEST_CONFIRMATION);
				this.retrievalCost = getCost(Services.EXAM_NUMBER_RETRIEVAL);

				
				this.calculateNairaValue();

      })
      .catch((err) => {
        console.warn(err);
      });
  }

	
	calculateNairaValue() {

		const rate = this.unitRate || 0; 

		this.localAccessCost = (this.accessCost || 0) * rate;
		this.localSharingCost = (this.sharingCost || 0) * rate;
		this.localRequestConfirmationCost = (this.requestConfirmationCost || 0) * rate;
		this.localRetrievalCost = (this.retrievalCost || 0) * rate;
		this.localVerificationCost = (this.verificationCost || 0) * rate;

	}

  toggleDropdown() {
    this.dropdownToggle = !this.dropdownToggle;
  }

  fundWallet() {
    this.isPaymentOption = true;
  }

  getCurrentUser() {
    this.profileService
      .getUser()
      .then((res) => {
        this.loading = false;
        this.user = res.data;
      })
      .catch((err) => {
        this.loading = false;
        console.error(err);
      });
  }

  forgot() {
    this.loading = true;
    let body = { email: this.user.email };
    this.passwordService
      .resetPassword(body)
      .then((res) => {
        this.loading = false;
        if (res.error) {
          this.notify.error("", res.message, NotificationKeys.BILLING);
          return;
        }
        this.notify.success("", res.message, NotificationKeys.BILLING);
      })
      .catch((res) => {
        console.warn(res);
        this.loading = false;
      });
  }

  handleModalCancel(): void {
    this.isVisible = false;
    this.isVisibleNegative = false;
    this.router.navigateByUrl("/");
  }

  confirmPayment() {
    let processor = null;
    let reference = null;

    this.route.queryParams.subscribe((params) => {
      processor = params?.processor;
      reference = params?.reference;
      if (!processor && !reference) return;

      if (
        processor == Processors.FLUTTERWAVE &&
        params?.status != PaymentStatus.SUCCESSFUL
      ) {
        this.analytics.transactionCompleted('failed', Services.WALLET);
        this.notify.error(
          "",
          this.translate.instant(
            "PROVISIONING.SHARE.PAYMENT_TRANSACTION_TEXT",
          ) +
            params.status +
            "!",
          NotificationKeys.BILLING,
        );
        this.router.navigateByUrl(this.router.url.split("?")[0]);
        return;
      }

      const body = {
        processor: processor,
        trxref: reference,
        reference: reference,
        transaction_id: params?.transaction_id,
      };
      this.transaction_details = body;
      this.paymentService
        .confirmPayment(body)
        .then((res) => {
          if (res.status === ResponseStatus.FAILED) {
            this.analytics.transactionCompleted('failed', Services.WALLET);
            this.getWalletBalance();
            this.pageLoading = false;
            this.trxerror = true;
            this.trxmessage = res.message;
            this.isVisibleNegative = true;
            return;
          }
          this.analytics.transactionCompleted('success', Services.WALLET);
          this.getWalletBalance();
          this.pageLoading = false;
          this.wallet_response = res;
          if (res.status == ResponseStatus.OK) this.isVisible = true;
        })
        .catch((err) => {
          this.pageLoading = false;
          this.trxerror = true;
          this.trxmessage = err;
        });
    });
  }

  getWallet = () => {
    this.loading_wallet = true;
    this.walletService.getwalletBalance().then((res: any) => {
      if (res?.error) {
        this.loading_wallet = false;
        return;
      }

      this.unitBalance = res?.data?.unit_balance;
      this.wallet = res?.data;
      this.loading_wallet = false;
      this.unitRate = res?.data?.currency_unit_rate;
      this.currency = res?.data?.payment_currency;
    });
  };

  reload() {
    this.walletBalance.sendBalance(BooleanStringValues.FALSE);
    this.getWallet();
  }

  onInitiateGenerateAccount() {
    this.isGenerateVirutalAccount = true;
  }

  getUserDetails() {
    this.profileService.getUser().then((res: any) => {
      if (res?.status === API_ResponseStatus.FAILED) {
        this.notify.error("", res?.message);
        return;
      }

      const userDetail = res?.data;
      const wallet = userDetail?.wallet;
      const institution_detail = userDetail?.institution_detail;
      const token = this.BrowserStorage.getLocalStorageItem(
        BrowserStorageKeys.token,
      );
      token["institution_detail"] = institution_detail;
      token["wallet"] = wallet;
      if (res?.virtual_account !== null) {
        const virtual_account = userDetail?.virtual_account;
        token["virtual_account"] = virtual_account;
      }

      this.BrowserStorage.setLocalStorageItem(BrowserStorageKeys.token, token);
      this.residentCountry = institution_detail?.resident_country;
    });
  }

  getVirtualAccountDetail() {
    const virtualAccount = this.BrowserStorage.getLocalStorageItem(
      BrowserStorageKeys.token,
    )?.virtual_account;
    if (!virtualAccount) {
      this.isAccountGenerated = false;
      return;
    }

    this.virtualAccountDetails = virtualAccount;
    this.isAccountGenerated = true;
  }

  onCopyAccountNumber() {
    this.clipboard.copy(this.virtualAccountDetails?.account_number);
    this.notify.success(
      this.virtualAccountDetails?.account_number,
      this.translate.instant("GENERAL.COPIED"),
    );
  }

  getVirtualProcessors() {
    this.walletService.getVirtualAccountProcessors().then((res: any) => {
      if (res?.status === API_ResponseStatus.FAILED) {
        this.notify.info("", res?.message);
        return;
      }

      this.virtualAccounts = res?.data;
    });
  }

  get hasAccountAndAccountActive() {
    let hasActiveAccount: boolean = false;
    const processorActiveStatus = ProcessorStatuses.ACTIVE;
    const hasVirtualAccount = this.userDetail?.virtual_account;
    const hasActiveVirtualAccount = this.virtualAccounts.some(
      (processor: any) =>
        processor?.status?.toLowerCase() == processorActiveStatus.toLowerCase(),
    );
    if (!hasVirtualAccount && hasActiveVirtualAccount) {
      hasActiveAccount = false;
    } else {
      hasActiveAccount = true;
    }

    return hasActiveAccount;
  }

  get institutionAccountStatus() {
    this.isLoading = true;
    let institutionAccountStatus: any;
    const institution_detail = this.BrowserStorage.getLocalStorageItem(
      BrowserStorageKeys.token,
    )?.institution_detail;

    if (!institution_detail || !Object.keys(institution_detail).length) {
      this.isLoading = false;
      return;
    }

    switch (institution_detail?.virtal_account_status?.toLowerCase()) {
      case InstitutionDetailStatus.PENDING.toLowerCase():
        institutionAccountStatus = InstitutionDetailStatus.PENDING;
        break;

      case InstitutionDetailStatus.FAILED.toLowerCase():
        institutionAccountStatus = InstitutionDetailStatus.FAILED;
        break;

      case InstitutionDetailStatus.CREATED.toLowerCase():
        institutionAccountStatus = InstitutionDetailStatus.CREATED;
        break;

      default:
        institutionAccountStatus = null;
        break;
    }

    this.isLoading = false;
    return institutionAccountStatus;
  }

  cancelPaymentOptionsModal(event: any) {
    if (!event) return;

    if (event == "GENERATE-ACCOUNT") this.isGenerateVirutalAccount = true;
    this.isPaymentOption = false;
    this.q.units = 0;
  }

  initiatePayment(event: any) {
    this.isPaymentOption = false;
  }

  getWalletBalance() {
    this.walletBalance.getbalance();
  }

  closeResultModal() {
    this.isGenerateVirutalAccount = false;
    this.isAccountGenerationSuccess = false;
    this.reconfirmAccountGneration();
  }

  closeVirtualAccountModal(event: any) {
    this.isGenerateVirutalAccount = false;
  }

  onConfirmAccountGeneration(event: any) {
    this.isAccountGenerationSuccess = true;
  }

  checkIfVirtualAccountGenerationInitiated() {
    this.route.queryParams.subscribe((qparam) => {
      if (!Object.keys(qparam).includes("virutalAccountGeneration")) return;
      this.virtualAccountGenerationInitiated = true;
      this.isGenerateVirutalAccount = true;
    });
  }

  reconfirmAccountGneration() {
    this.walletService
      .generateVirtualAccount()
      .then((res: any) => {
        if (res?.status === API_ResponseStatus.FAILED) {
          this.BrowserStorage.removeSessionStorageItem(
            BrowserStorageKeys.virtualAccountGenerated,
          );
          this.isGenerateVirutalAccount = false;
          this.getUserDetails();
          return;
        }

        if (!res?.data) {
          this.isGenerateVirutalAccount = false;
          this.getUserDetails();
          return;
        }

        this.notify.success("", res?.message);
        this.isGenerateVirutalAccount = false;
        this.getUserDetails();
      })
      .catch((err: any) => {
        this.BrowserStorage.removeSessionStorageItem(
          BrowserStorageKeys.virtualAccountGenerated,
        );
        this.getUserDetails();
        this.isGenerateVirutalAccount = false;
      });
  }

  checkStatus() {
    this.profileService
      .getUser()
      .then((res: any) => {
        if (res?.status === API_ResponseStatus.FAILED) {
          this.notify.error("", res?.message);
          return;
        }

        const resp = res?.data;
        if (resp?.virtual_account !== null) {
          this.notify.success("", this.translate.instant('BILLING.VIRTUAL_ACCOUNT_CREATED'));
          this.institutionAccountStatus === InstitutionDetailStatus.CREATED;
          const token = this.storageSrv.getLocalStorageItem(
            BrowserStorageKeys.token,
          );
          token["virtual_account"] = resp?.virtual_account;

          this.storageSrv.setLocalStorageItem(BrowserStorageKeys.token, token);
        } else {
          this.notify.info(
            "",
            this.translate.instant('BILLING.VIRTUAL_ACCOUNT_CREATION_TEXT')
          );
        }
      })
      .catch((err: any) => {
        this.notify.error("", err?.error?.message);
        // this.getUserDetails();
      });
  }

	isLocalCountry() {
		return this.residentCountry === this.userCountry?.code;
	}

  isLocalTransaction() {
    return this.currency === this.userCountry?.currency;
  }

  closeExamCountrySetupModal() {
    this.examCountrySetup?.modalRef?.close();  
  }
	
}
